import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Header } from './Website/Components/common/header/header';
import { Hero } from './Website/features/home/hero/hero';
import { EmpoweringDoctors } from './Website/features/home/empoweringdoctors/empoweringdoctors';
import { MedicalExperts } from './Website/features/home/medicalexperts/medicalexperts';
import { PartnerHospitals } from './Website/features/home/partnerhospitals/partnerhospitals';
import { Internationalcollaborations } from './Website/features/home/internationalcollaborations/internationalcollaborations';
import { Livesessions } from './Website/features/home/livesessions/livesessions';
import { Onlineclinics } from './Website/features/home/onlineclinics/onlineclinics';
import { Bizaariostore } from './Website/features/home/bizaariostore/bizaariostore';
import { Awardscertification } from './Website/features/home/awardscertification/awardscertification';
import { Newsarticles } from './Website/features/home/newsarticles/newsarticles';
import { Testimonial } from './Website/features/home/testimonial/testimonial';
import { Footer } from './Website/Components/common/footer/footer';
import { AboutUs } from './Website/features/aboutus/aboutus';
import { BizaarioStorePage } from './Website/features/bizaariostore/BizaarioStorePage';
import { Hospitalspartners } from './Website/features/hospitalspartners/hospitalspartners';
import { Medicalboard } from './Website/features/medicalboard/medicalboard';
import { Newsarticals } from './Website/features/newsarticals/newsarticals';
import { Contactus } from './Website/features/contactus/contactus';
import { Newsarticalsdetails } from './Website/features/newsarticalsdetails/newsarticalsdetails';
import { Signup } from './Website/features/auth/signup/signup';
import { Login } from './Website/features/auth/login/login';
import { ForgotPassword } from './Website/features/auth/forgotpassword/forgotpassword';
import { CasestudyDetails } from './Website/features/casestudydetails/CasestudyDetails';
import { caseStudies } from './Website/data/caseStudies';
import { Cme } from './Website/features/cme/cme';
import { Livesession } from './Website/features/livesession/livesession';
import { LiveSessionDetails } from './Website/features/livesessiondetails/LiveSessionDetails';
import { liveSessions } from './Website/data/liveSessions';
import { Internationalhospitalcollaborations } from './Website/features/internationalhospitalcollaborations/internationalhospitalcollaborations';
import { Internationaldoctercollaborations } from './Website/features/internationaldoctercollaborations/internationaldoctercollaborations';
import { ScrollToTop } from './Website/utils/ScrollToTop';
import { Livesesstionvideo } from './Website/features/home/livesesstionvideo/livesesstionvideo';
import { AuthDataPage } from './Website/features/auth/authdatapage/authdatapage';
import { AdminDashboard } from './Website/features/admin/dashboard/AdminDashboard';
import { HospitalProfilePage } from './Website/features/hospital-profiles/HospitalProfilePage';
import { DoctorProfilePage } from './Website/features/doctor-profiles/DoctorProfilePage';
import { Cmedetailspage } from './Website/features/cmedetailspage/cmedetailspage';
import { Productdetails } from './Website/features/productdetails/productdetails';

const Home = () => {
  return (
    <>
      <Hero />
      <EmpoweringDoctors />
      <MedicalExperts />
      <PartnerHospitals />
      <Internationalcollaborations />
      {/* <Livesessions /> */}
      <Livesesstionvideo/>
      <Onlineclinics />
      <Bizaariostore />
      <Awardscertification />
      <Newsarticles />
      <Testimonial />
    </>
  );
};

const MainLayout = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
  </>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route
          path="*"
          element={
            <MainLayout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/store" element={<BizaarioStorePage />} />
                <Route path="/store/:slug" element={<Productdetails />} />
                <Route path="/hospitals" element={<Hospitalspartners />} />
                <Route path="/hospitals/:slug" element={<HospitalProfilePage />} />
                <Route path="/medical-board" element={<Medicalboard />} />
                <Route path="/doctors/:slug" element={<DoctorProfilePage />} />
                <Route path="/news-articles" element={<Newsarticals />} />
                <Route path="/news-articles/:slug" element={<Newsarticalsdetails />} />
                <Route path="/contact" element={<Contactus />} />
                <Route path="/case-studies" element={<Navigate to={`/case-studies/${caseStudies[0].slug}`} replace />} />
                <Route path="/case-studies/:slug" element={<CasestudyDetails />} />
                <Route path="/cme" element={<Cme />} />
                <Route path="/cme/:slug" element={<Cmedetailspage />} />
                <Route path="/live-sessions" element={<Navigate to={`/live-sessions/${liveSessions[0].slug}`} replace />} />
                <Route path="/live-sessions/:slug" element={<LiveSessionDetails />} />
                <Route path="/international-collaborations" element={<Internationalhospitalcollaborations />} />
                <Route path="/international-doctor-collaborations" element={<Internationaldoctercollaborations />} />
                <Route path="/authdatapage" element={<AuthDataPage/>} />
              </Routes>
            </MainLayout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
